import {
  WORKLOG_REPORTS_WEEK_SELECTED,
  WORKLOG_REPORTS_VIEW_DATA,
  WORKLOG_REPORTS_DEFAULT_PROJECT_DATA,
} from "../../typesAction";

const INITIAL_STATE = {
  data: [],
  stats: [],
  projects: [],
  week: null,
  year: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case WORKLOG_REPORTS_WEEK_SELECTED:
      return { ...state, week: action.payload.week, year: action.payload.year };
    case WORKLOG_REPORTS_VIEW_DATA:
      return {
        ...state,
        data: action.payload.data,
        stats: action.payload.stats?.[0],
      };
    case WORKLOG_REPORTS_DEFAULT_PROJECT_DATA:
      return { ...state, projects: action.payload };
    default:
      return state;
  }
}
